import React, { Component } from 'react';
import Header from './Header';
import Order from './Order';
import Fish from './Fish';
import base from '../base';
import PropTypes from 'prop-types';

class App extends Component {
  state = {
    fishes: {},
    order: {}
  };

  static propTypes = {
    match: PropTypes.object
  };

  componentDidMount(){
    const params = this.props.match.params.storeId;
    const localStorageRef = localStorage.getItem(params)
    if(localStorageRef){
      this.setState({ order: JSON.parse(localStorageRef) });
    }
    this.ref = base.syncState(`${params}/fishes`, {
      context: this,
      state: 'fishes'
    });
  };

  componentDidUpdate(){
    localStorage.setItem(
      this.props.match.params.storeId, JSON.stringify(this.state.order)
    )
  };

  componentWillUnmount(){
    base.removeBinding(this.ref);
  };

  addToOrder = (key) => {
    const order = { ...this.state.order};
    order[key] = order[key] + 1 || 1;
    this.setState({ order: order });
  };

  removeFromOrder = (key) => {
    const order = { ...this.state.order};
    delete order[key];
    this.setState({ order: order });
  }

  goToAdmin = e => {
    this.props.history.push(`/store/fintastic/admin`);
    console.log("gotoadmin");
  }

  render(){
    return(
      <div>
        <button className="store-login" onClick={this.goToAdmin}>Manage Store</button>

        <Order
          fishes={this.state.fishes}
          order={this.state.order}
          removeFromOrder={this.removeFromOrder}
          history={this.props.history}
        />

        <div className="catch-of-the-day">
          <div className="menu">
            <Header tagline="Fresh Seafood Market" />
            <ul className="fishes">
              {Object.keys(this.state.fishes).map(key =>
                <Fish
                key={key}
                details={this.state.fishes[key]}
                addToOrder={this.addToOrder}
                index={key}
                /> )}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js